import type { ReactNode } from 'react';
import type { PermissionCode } from '@amai/contracts';
import { canOpen } from '@/navigation';
import { useAuth } from '@/lib/auth-context';
import { ForbiddenPage } from '@/routes/Fallbacks';

/**
 * Esconde a tela de quem não tem a permissão.
 *
 * É conveniência de UX, não segurança: o servidor recusa de novo em cada rota.
 */
export function Guarded({
  permission,
  children,
}: {
  permission: PermissionCode | PermissionCode[];
  children: ReactNode;
}) {
  const { can } = useAuth();
  return canOpen(can, permission) ? <>{children}</> : <ForbiddenPage />;
}
